export default __webpack_public_path__ + "static/media/album-image-3.01428a63.svg";